import * as React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@material-ui/core';

export default function AlertDialog({ title, content, okFunction, open, setOpen }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ minWidth: '476px' }}
      >
        <DialogTitle id="alert-dialog-title">
          <Typography sx={{ textAlign: 'center' }} variant="h6">
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent style={{ paddingBottom: 0, paddingTop: '20px' }}>
          <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={okFunction} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
